import axios from '@axios'
import store from './../../store'

export default {
  namespaced: true,
  state: {
    pagination: {
      current_page: 1,
      total: 0,
      count: 20
    },
    controls: [],
  },
  getters: {},
  mutations: {
    SET_PAGINATION (state, pagination) {
      Object.assign(state.pagination, pagination)
    },
    SET_CONTROLS(state, data) {
      state.controls = data.data;
      state.pagination = data.pagination;
    },
    UPDATE_CONTROLS(state, data) {
      let index = state.controls.findIndex(e => e._id === data.item._id)
      if (index >= 0) {
        Object.assign(state.controls[index], {
          ...state.controls[index],
          status: data.item.status,
        })
      }
    }
  },
  actions: {
    getControls ({commit}, query) {
      return new Promise((resolve, reject) => {
        axios.get(`list-controls?${query}`)
          .then(response => {
            commit("SET_CONTROLS", response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    updateControls({commit}, {id, data}) {
      return new Promise((resolve, reject) => {
        axios.put(`list-controls/${id}`, data)
            .then(response => {
              commit("UPDATE_CONTROLS", response.data)
              resolve(response)
            })
            .catch(error => {
              reject(error)
            })
      })
    }
  }
}
